import React from 'react';
import TableRow from '../TableRow';
import TableData from '../TableData';
import Skeleton from '../../skeleton/Skeleton';
import { Column } from './types';

interface Props<T> {
  loadingItemCount?: number;
  columns: Column<T>[];
  height?: string;
}

function Loading<T>({
  loadingItemCount,
  columns,
  height = '1.5rem',
}: Props<T>) {
  return Array(loadingItemCount)
    .fill(0)
    .map((_, i) => (
      <TableRow key={i}>
        {columns?.length ? (
          columns?.map((item, key) => (
            <TableData key={key}>
              <Skeleton className="rounded-2" height={height} />
            </TableData>
          ))
        ) : (
          <TableData key={i}>
            <Skeleton className="rounded-2" height={height} />
          </TableData>
        )}
      </TableRow>
    ));
}

export default Loading;
